export default __webpack_public_path__ + "static/media/GHSI Special Board Minutes 20 July 2022.e348827f.pdf";